import { GET_STARTED_URL } from '../../_data/marketingLinks'
import type { MarketingCtaStripProps } from './types'
import {
  Actions,
  Body,
  Eyebrow,
  Headline,
  Inner,
  PrimaryButton,
  SecondaryButton,
  Section,
} from './styled'

const MarketingCtaStrip = ({
  eyebrow,
  headline,
  body,
  primaryLabel = 'Get started',
  secondaryLabel,
  secondaryHref,
}: MarketingCtaStripProps): JSX.Element => (
  <Section>
    <Inner>
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <Headline>{headline}</Headline>
      <Body>{body}</Body>
      <Actions>
        <PrimaryButton href={GET_STARTED_URL}>{primaryLabel}</PrimaryButton>
        {secondaryLabel && secondaryHref ? (
          <SecondaryButton href={secondaryHref}>
            {secondaryLabel}
          </SecondaryButton>
        ) : null}
      </Actions>
    </Inner>
  </Section>
)

export default MarketingCtaStrip
